import React from 'react';
import { cond, prop, propEq, sortBy } from 'ramda';

import { getTarget, getWithPrefix } from '../../utils';
import { renderWhenTrue } from '../../utils/rendering';
import { Card, ContentMarkdown, Link } from './cardLeft.styles';

import { useIntl } from 'gatsby-plugin-intl';
const renderers = {
  link: Link,
};

const renderMarkdown = ({ value }, key) => {
  const intl = useIntl();

  return (
    <ContentMarkdown renderers={renderers} key={key}>
      {intl.formatMessage({ id: value })}
    </ContentMarkdown>
  );
};

const renderLink = ({ value }, key) => {
  const intl = useIntl();
  return renderWhenTrue(() => (
    <Link key={key} href={getWithPrefix(value)} target={getTarget(value)}>
      {intl.formatMessage({ id: 'Learn More' })}
    </Link>
  ))(!!value);
};

const renderElement = cond([
  [propEq('type', 'markdown'), renderMarkdown],
  [propEq('type', 'connection'), renderLink],
]);

export const CardLeft = ({ elements, isVisible }) => {
  const orderedElements = sortBy(prop('order'))(elements);

  return <Card isVisible={isVisible}>{orderedElements.map(renderElement)}</Card>;
};
